"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseNumberInput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _bignumber = require("bignumber.js");
var _classnames = _interopRequireDefault(require("classnames"));
var _numberFormatter = require("../../../helpers/numberFormatter/numberFormatter");
var _parseNumber = require("../../../helpers/numberFormatter/parseNumber");
var _useCursor3 = require("./hooks/useCursor");
require("./NumberInput.css");
var _excluded = ["value", "onChange", "formatter", "decimalPlaces", "valueAs", "className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * @typedef {Object} BaseNumberInputProps
 * @prop {string|number|BigNumber} value
 * @prop {(value: string|number|BigNumber) => void} onChange
 *     Event handler for the change event. The event will not be dispatched if the value is in intermediate state (incomplete number).
 * @prop {(BigNumber) => string} [formatter] Optional formatter to override default formatting.
 *     It will be ignored when `value` is an incomplete number.
 * @prop {number} [decimalPlaces] Optional decimal places to format the number.
 *     If omitted, the value will be formatted without rounding.
 * @prop {'string'|'number'|'BigNumber'} [valueAs]
 *     Optional value type to dispatch the change event with (default is 'number').
 */

/**
 * @typedef {Object} BaseNumberInputRef
 * @prop {HTMLInputElement} inputEl
 * @prop {() => BigNumber} getValue
 * @prop {(value: BigNumber|string|number) => void} setValue
 * @prop {(value: BigNumber) => string} formatValue
 */

/**
 * Parses a string with the formatted number to a BigNumber.
 * @param {string} rawValue
 * @param {boolean} [allowIncompleteNumber] Allows rawValue to be an incomplete number (useful for user inputs)
 * @returns {BigNumber|null}
 */
function string2BigNumber(rawValue) {
  var allowIncompleteNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var delimeters = (0, _numberFormatter.getLocaleSettings)();
  var cleanedValue = (0, _parseNumber.cleanFormattedString)(rawValue, delimeters, allowIncompleteNumber);
  return cleanedValue !== null ? (0, _parseNumber.parseNumber)(cleanedValue, true) : null;
}

/**
 *
 * @param {string|number|BigNumber} value
 * @returns {string}
 */
function parseProvidedValue(value, decimalPlaces) {
  var bigValue = null;
  if (typeof value === 'number' || _bignumber.BigNumber.isBigNumber(value)) {
    bigValue = (0, _bignumber.BigNumber)(value);
  } else if (value) {
    bigValue = string2BigNumber(value);
  }
  return bigValue !== null ? (0, _numberFormatter.formatNumberToLocale)(bigValue, Math.min(bigValue.dp(), decimalPlaces)) : '';
}

/**
 * Base component for number input that handles parsing, formatting and value storage.
 * @param {BaseNumberInputProps} props
 * @param {React.Ref<BaseNumberInputRef>} ref
 */
var BaseNumberInput = exports.BaseNumberInput = /*#__PURE__*/(0, _react.forwardRef)(
/**
 * @param {BaseNumberInputProps} props
 * @param {React.Ref<BaseNumberInputRef>} ref
 */
function BaseNumberInput(_ref, ref) {
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    onChange = _ref.onChange,
    formatter = _ref.formatter,
    _ref$decimalPlaces = _ref.decimalPlaces,
    decimalPlaces = _ref$decimalPlaces === void 0 ? 0 : _ref$decimalPlaces,
    _ref$valueAs = _ref.valueAs,
    valueAs = _ref$valueAs === void 0 ? 'number' : _ref$valueAs,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var inputRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    focused = _useState2[0],
    setFocus = _useState2[1];

  //#region Parse, store and format value
  /**
   * @type {[string, React.Dispatch<React.SetStateAction<string>>]}
   */
  var _useState3 = (0, _react.useState)(function () {
      return parseProvidedValue(value, decimalPlaces);
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    rawValue = _useState4[0],
    setRawValue = _useState4[1];
  (0, _react.useEffect)(function () {
    // update the input's value with provided value when it isn't focused
    if (!focused) {
      setRawValue(parseProvidedValue(value, decimalPlaces));
    }
  }, [value, decimalPlaces, focused]);
  var parsedValue = (0, _react.useMemo)(function () {
    return string2BigNumber(rawValue, focused);
  }, [rawValue, focused]);

  /**
   * @type {(BigNumber) => string}
   */
  var formatValue = (0, _react.useCallback)(function (value) {
    return formatter ? formatter(value) : (0, _numberFormatter.formatNumberToLocale)(value, Math.min(value.dp(), decimalPlaces));
  }, [formatter, decimalPlaces]);
  var displayValue = !_bignumber.BigNumber.isBigNumber(parsedValue) || !parsedValue.isFinite() ? rawValue : formatValue(parsedValue);
  var returnValue = valueAs === 'BigNumber' ? parsedValue : parsedValue === null ? '' // TODO: should we return null instead for valueAs='number'?
  : valueAs === 'string' ? parsedValue.toFormat(decimalPlaces, {
    decimalSeparator: '.',
    groupSeparator: ''
  }) : parsedValue.dp(decimalPlaces).toNumber();
  (0, _react.useEffect)(function () {
    onChange(returnValue);
  }, [returnValue, onChange]);
  // #endregion

  // #region Manage cursor position
  var _useCursor = (0, _useCursor3.useCursor)(inputRef.current, focused),
    _useCursor2 = _slicedToArray(_useCursor, 2),
    recordCursor = _useCursor2[0],
    restoreCursor = _useCursor2[1];
  var firstMount = (0, _react.useRef)(true);
  (0, _react.useLayoutEffect)(function () {
    if (firstMount.current) {
      firstMount.current = false;
      return;
    }
    restoreCursor();
  }, [displayValue]); // eslint-disable-line react-hooks/exhaustive-deps
  // #endregion

  (0, _react.useImperativeHandle)(ref, function () {
    return {
      inputEl: inputRef.current,
      getValue: function getValue() {
        return parsedValue;
      },
      /**
       * @param {BigNumber|string|number} value
       */
      setValue: function setValue(value) {
        setRawValue(_bignumber.BigNumber.isBigNumber(value) ? value.toFormat() : value);
      },
      formatValue: formatValue
    };
  });
  var validateInputSymbols = (0, _react.useCallback)(function (e) {
    var allowedKeys = ['Backspace', 'Tab', 'Enter', 'Escape', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Meta',
    // Command key on Mac
    'Control', 'Alt', 'Shift'];
    var allowedSymbols = ['-', '.', ','];
    if (allowedKeys.includes(e.key) || e.ctrlKey || e.metaKey // Allow copy, paste, cut, select all
    ) {
      // Allow control keys
      return;
    }
    if (e.key >= '0' && e.key <= '9' || allowedSymbols.includes(e.key) && !e.target.value.includes(e.key)) {
      // Check decimal places limit
      if (e.key >= '0' && e.key <= '9' && decimalPlaces !== undefined) {
        var currentValue = e.target.value;
        var cursorPosition = e.target.selectionStart;
        var delimeters = (0, _numberFormatter.getLocaleSettings)();

        // Construct the new value that would result from this keystroke
        var newValue = currentValue.slice(0, cursorPosition) + e.key + currentValue.slice(e.target.selectionEnd);

        // Find decimal separator position
        var decimalIndex = newValue.indexOf(delimeters.decimal);
        if (decimalIndex !== -1) {
          // Count decimal places in the new value
          var decimalPart = newValue.slice(decimalIndex + 1).replace(new RegExp(escapeRegExp(delimeters.thousands), 'g'), '');
          if (decimalPart.length > decimalPlaces) {
            e.preventDefault();
            return;
          }
        }
      }
      // Allow numbers and allowed symbols
      return;
    }

    // Prevent any other input
    e.preventDefault();
  }, [decimalPlaces]);

  // Helper function for escaping regex special characters
  var escapeRegExp = function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };
  var handlePaste = (0, _react.useCallback)(function (e) {
    if (decimalPlaces === undefined) return;
    var pastedText = e.clipboardData.getData('text');
    var currentValue = e.target.value;
    var cursorPosition = e.target.selectionStart;
    var delimeters = (0, _numberFormatter.getLocaleSettings)();

    // Construct the new value that would result from this paste
    var newValue = currentValue.slice(0, cursorPosition) + pastedText + currentValue.slice(e.target.selectionEnd);

    // Find decimal separator position (check both . and locale-specific separator)
    var decimalIndex = newValue.indexOf(delimeters.decimal);
    if (decimalIndex === -1 && delimeters.decimal !== '.') {
      decimalIndex = newValue.indexOf('.');
    }
    if (decimalIndex !== -1) {
      // Count decimal places in the new value
      var decimalPart = newValue.slice(decimalIndex + 1).replace(new RegExp(escapeRegExp(delimeters.thousands), 'g'), '');
      if (decimalPart.length > decimalPlaces) {
        e.preventDefault();
      }
    }
  }, [decimalPlaces]);
  return /*#__PURE__*/_react["default"].createElement("input", _extends({
    className: (0, _classnames["default"])('input--number', className),
    ref: inputRef,
    autoComplete: "off"
  }, props, {
    value: displayValue,
    onChange: function onChange(e) {
      recordCursor();
      setRawValue(e.target.value);
    },
    onKeyDown: validateInputSymbols,
    onPaste: handlePaste,
    onFocus: function onFocus(e) {
      var _props$onFocus;
      setFocus(true);
      (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 || _props$onFocus.call(props, e);
    },
    onBlur: function onBlur() {
      var _props$onBlur;
      setFocus(false);
      // onBlur should get the same value as onChange. Otherwise the redux-form will pick the input's value from e.target.value
      (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 || _props$onBlur.call(props, returnValue);
    }
  }));
});